import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUploader } from '../uploader/useUploader';
import { IHtmlEditorLayout } from '../../types/layout/html-editor';
import { LayoutContext } from '../../contexts/layout';
import { setFormFieldInitialValue } from '../../redux/actions/forms';
import { formDataLoadedSelector, getFormValues } from '../../redux/selectors/forms';
import { layoutStateSelector } from '../../redux/selectors/layouts';

export const useHtmlEditor = ({ dataIndex, mode }: IHtmlEditorLayout) => {
    const { layoutId } = useContext(LayoutContext);
    const dispatch = useDispatch();
    const { getFileData } = useUploader({ dataLink: '' } as any, true);
    const [fileLoading, setFileLoading] = useState(false);
    const formDataLoaded = useSelector(formDataLoadedSelector(layoutId));
    const formValues = useSelector(getFormValues(layoutId));
    const parentLayout = useSelector(layoutStateSelector(layoutId));

    const processFileData = async () => {
        if (mode === 'file' && formDataLoaded && Array.isArray(formValues.files)) {
            const uploadedFile = formValues.files.find((el) => el.fileName === `[html-editor]-${dataIndex}.txt`);
            if (typeof uploadedFile?.fileId === 'string') {
                setFileLoading(true);
                const fileData = await getFileData(uploadedFile.fileId);
                dispatch(setFormFieldInitialValue(layoutId, dataIndex, fileData));
                setFileLoading(false);
            }
        }
    };

    useEffect(() => {
        processFileData();
    }, [formDataLoaded, parentLayout.data]);

    return {
        loading: fileLoading,
    };
};
